import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function GroupingIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M8.25 9.5L10.65 13.6569M5.25 9H15.25C16.3546 9 17.25 8.10457 17.25 7C17.25 5.89543 16.3546 5 15.25 5H5.25C4.14543 5 3.25 5.89543 3.25 7C3.25 8.10457 4.14543 9 5.25 9ZM9.25 18H19.25C20.3546 18 21.25 17.1046 21.25 16C21.25 14.8954 20.3546 14 19.25 14H9.25C8.14543 14 7.25 14.8954 7.25 16C7.25 17.1046 8.14543 18 9.25 18Z"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
};
